import { themeOptions } from '@glg/cx-lib-theme';
import { Box, ScopedCssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { SiteHeader } from './components/SiteHeader';
import { SiteFooter } from './components/SiteFooter';
import { SupportForm } from './components/SupportForm';

const theme = createTheme(themeOptions());

export const App = (): JSX.Element => {
  return (
    <ThemeProvider theme={theme}>
      <ScopedCssBaseline>
        <Box
          className='support-page'
          sx={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: 'grey.50'
          }}
        >
          <SiteHeader />
          <Box
            component='main'
            className='support-main'
            sx={{ flex: '1 0 auto', display: 'flex', justifyContent: 'center', px: 2, py: 5 }}
          >
            <SupportForm />
          </Box>
          <SiteFooter />
        </Box>
      </ScopedCssBaseline>
    </ThemeProvider>
  );
};
